export default function CguRequired(store) {
  return store.getters["user/cgu"];
}
